import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card } from "@/components/ui/card";
import { CarFront, Wrench } from "lucide-react";
import { API } from "@/lib/api";

export const EasyCarVIN24CustomerContext = ({ customerId }) => {
  const [orders, setOrders] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    if (!customerId) { setOrders([]); setLoaded(true); return undefined; }
    setLoaded(false);
    axios.get(`${API}/integrations/easycarvin24/customers/${encodeURIComponent(customerId)}/context`)
      .then((r) => { if (active) setOrders(r.data?.work_orders || []); })
      .catch(() => { if (active) setOrders([]); })
      .finally(() => { if (active) setLoaded(true); });
    return () => { active = false; };
  }, [customerId]);

  if (!loaded || orders.length === 0) return null;
  return <Card className="p-5 border-[var(--brand-border)]" data-testid="easycarvin24-customer-context">
    <div className="flex items-center gap-2 mb-1"><CarFront className="w-4 h-4 text-[var(--brand-primary)]" /><span className="font-semibold text-[var(--brand-ink)]">Fahrzeug- & Werkstattkontext</span></div>
    <p className="text-xs text-[var(--brand-muted)] mb-3">Verbundene Aufträge aus EasyCarVIN24. Fahrzeug- und Werkstattdaten bleiben dort führend; hier erscheinen sie nur als Kontext.</p>
    <div className="space-y-2">
      {orders.map((order) => {
        const vehicle = order.vehicle || {};
        const vehicleLabel = [vehicle.license_plate, vehicle.make, vehicle.model].filter(Boolean).join(" · ");
        return <div key={order.id} className="flex flex-wrap items-start justify-between gap-2 rounded-lg border border-[var(--brand-border)] p-3">
          <div><p className="text-sm font-medium text-[var(--brand-ink)]">{vehicleLabel || "Fahrzeugkontext"}</p><p className="text-xs text-[var(--brand-muted)] mt-1"><Wrench className="inline w-3 h-3 mr-1" />Auftrag {order.external_work_order_id} · {order.positions?.length || 0} Positionen · Status: {order.status || "offen"}</p></div>
          {vehicle.vin_masked && <span className="text-[11px] text-[var(--brand-muted)]">VIN: {vehicle.vin_masked}</span>}
        </div>;
      })}
    </div>
  </Card>;
};
